export { default } from "./v1/Slim";
export { default as PromoBannerSlimV2 } from "./v2/Slim.v2";
export { default as PromoBannerSlimV2SideRail } from "./v2/Slim.v2.SideRail";
